<template>
  <div v-if="dataList.length > 0" class="top_article">
    <div class="top_item" v-for="item in dataList" @click="eventClick(item.url)" :key="item.id">
      <span>置顶</span>
      <span class="pointer">{{ item.title }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dataList: []
      }
    },
    mounted() {
      this.showPage()
    },
    methods: {
      showPage() {
        this.$API.TopList({
          plate: this.$route.meta.top
        }).then(res => {
          if(res.data.code == 200) {
            this.dataList = res.data.data
          }
        })
      },
      eventClick(url) {
        window.open(url)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .top_article {
    width: 900px;
    background: #fafafa;
    border-radius: 4px;
    margin: 10px 0;
    padding: 15px 0;

    .top_item {
      padding: 10px 20px;
      display: flex;

      &:hover {
        background: #F2F3F5;
      }

      &:active {
        background: #ECEDEF;
      }

      & > span {
        font-size: 14px;
        font-weight: 600;
        color: #1d2129;
        line-height: 20px;

        &:first-child {
          width: 44px;
          height: 20px;
          background: #f26257;
          border-radius: 2px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
          margin-right: 13px;
        }
      }
    }
  }
</style>